import { FormGroup } from "reactstrap";
import { useEffect, useState } from "react";
import { Button } from "reactstrap";

interface IOption {
  value: string;
  text: string;
}
interface IInput {
  name: string;
  value: string;
  onChange: (value: string) => void;
}
interface SelectButtonField2Props {
  input: IInput;
  label: string;
  values: IOption[];
  isRequired: boolean;
}

const SelectButtonField2 = ({
  input,
  label,
  values,
  isRequired
}: SelectButtonField2Props) => {
  const [selected, setSelected] = useState("");

  const onChangeValues = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    const value = (event.target as HTMLButtonElement).value;
    setSelected(value);
    input.onChange(value);
  };

  useEffect(() => {
    setSelected(input.value);
  }, [input.value]);

  return (
    <FormGroup className="leadOptions mt-0">
      <label>{label} {isRequired && <span className="input-required">*</span>}</label>
      <div className="d-flex">
        {values?.map((element: IOption, index: number) => (
          
          <Button
            key={input.name + index}
            type="button"
            name={input.name}
            className={`${
              element.value == selected ? "optSelected" : "optionBox"
            }`}
            value={element.value}
            onClick={onChangeValues}
            active={element.value === selected}
          >
            {element.text}
          </Button>
        ))}
      </div>
    </FormGroup>
  );
};

export default SelectButtonField2;
